export const validateUsername = (username: string): { isValid: boolean; error?: string } => {
  if (!username) {
    return { isValid: false, error: "Username is required" };
  }

  if (username.length < 5 || username.length > 20) {
    return { isValid: false, error: "Username must be between 5 and 20 characters" };
  }

  // Only allow letters, numbers, and underscores
  const validUsernameRegex = /^[a-zA-Z0-9_]+$/;
  if (!validUsernameRegex.test(username)) {
    return { isValid: false, error: "Username can only contain letters, numbers, and underscores" };
  }

  return { isValid: true };
};